import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { IVideo } from "../../admin/videos/hooks/useFetchVideos";
import { SelectedVideoCard } from "../../admin/videos/components/SelectedVideoCard";
import { VideosContainer } from "../../admin/videos/components/VideosContainer";
import axiosInstant from "../../../api";
import { VideoContextWrapper } from "../../admin/videos/context/video";
import { WhiteBackground } from "../../../components/WhiteBackground";
import { EmptyPanel } from "../../brand/projects/common/EmptyPanel";
import { MainContainer } from "../../../components/ContentWrapper";
import { DotLottleLoader } from "../../../components/Loader";

export function MyProVideos() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [videoId, setVideoId] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [videos, setVideos] = useState<Array<IVideo>>([]);

  const handleSelectVideo = (video: IVideo) => {
    setVideoId(video.id);
    if (video.id) searchParams.set("video", String(video.id));
    else searchParams.delete("video");
    setSearchParams(searchParams);
  };

  const fetchVideos = () => {
    setLoading(true);
    axiosInstant.get("/users/me/videos").then((response) => {
      setVideos(response.data.rows);
      setLoading(false);
    });
  };

  const handleResetVideo = () => {
    setSearchParams();
    setVideoId(null);
  };

  useEffect(fetchVideos, []);

  return (
    <WhiteBackground>
      <VideoContextWrapper>
        {videoId ? (
          <Box flexGrow={1}>
            <SelectedVideoCard
              videoId={videoId}
              onClose={() => handleResetVideo()}
              type="file"
              refetch={fetchVideos}
            />
          </Box>
        ) : (
          <MainContainer title="videos">
            <Box className="flex gap-0">
              <Typography className="w-[110px] text-text-2">
                {videos.length} Videos
              </Typography>
              <div className="mt-3 border-t w-full border-border-token" />
            </Box>
            <Box
              height="auto"
              maxWidth="auto"
              flexGrow={1}
              sx={{
                overflow: "visible",
                paddingRight: "16px",
                marginRight: "16px",
                marginTop: 8,
              }}
            >
              {loading && !videos.length ? (
                <DotLottleLoader fill={false} />
              ) : !loading && !videos.length ? (
                <EmptyPanel
                  title="You have no videos."
                  text="When videos are completed for a project they will appear here."
                />
              ) : (
                <Box
                  sx={{
                    overflow: "visible",
                    marginRight: "-30px",
                  }}
                >
                  <VideosContainer
                    loading={loading}
                    videos={videos}
                    onSelectVideo={handleSelectVideo}
                    selectedVideoId={videoId}
                  />
                </Box>
              )}
            </Box>
          </MainContainer>
        )}
      </VideoContextWrapper>
    </WhiteBackground>
  );
}
